module.exports = __webpack_public_path__ + "media/images/icons/clock-cb7315162598d4d4bbcb7761a3289f18.svg";